/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { ClaimsSchemaFieldLinkValueLinkType } from './ClaimsSchemaFieldLinkValueLinkType';

export const ClaimsSchemaFieldLinkValue: core.serialization.ObjectSchema<
    serializers.ClaimsSchemaFieldLinkValue.Raw,
    Truvity.ClaimsSchemaFieldLinkValue
> = core.serialization.object({
    isArray: core.serialization.property('is_array', core.serialization.boolean().optional()),
    linkType: core.serialization.property('link_type', ClaimsSchemaFieldLinkValueLinkType.optional()),
    name: core.serialization.string(),
    notEmpty: core.serialization.property('not_empty', core.serialization.boolean().optional()),
    title: core.serialization.string().optional(),
});

export declare namespace ClaimsSchemaFieldLinkValue {
    export interface Raw {
        is_array?: boolean | null;
        link_type?: ClaimsSchemaFieldLinkValueLinkType.Raw | null;
        name: string;
        not_empty?: boolean | null;
        title?: string | null;
    }
}
